module.exports = "<div id='acordeao-conteiner' class='acordeao'>\r\n  <ng-content></ng-content>\r\n</div>\r\n"